import axios, { AxiosInstance } from 'axios';
import { getToken } from '../auth/Login/AuthService';

/**
 * Creates a new Axios instance with a request interceptor that injects the
 * current JWT token from localStorage on every request.
 *
 * Use `createApiClient()` when you need a dedicated instance (e.g. to attach
 * custom response interceptors). Use the default export `apiClient` for all
 * standard service calls.
 */
export function createApiClient(): AxiosInstance {
  const instance = axios.create();
  instance.interceptors.request.use((config) => {
    const token = getToken();
    if (token) {
      config.headers.Authorization = token;
    }
    return config;
  });
  return instance;
}

const apiClient = createApiClient();

export default apiClient;
